<template>
  <div class="od-card-container margin-right-8 flex-1">
    <div class="odc-header-container">
      <div class="odc-header">
        Billing Address
      </div>
      <button
        type="button"
        class="edit-btn"
        @click="toggleActionModal(true, 'update-billing-address')"
      >
        EDIT
      </button>
    </div>
    <div class="odc-body-container">
      <div class="odcb-info-container">
        <div class="odcb-body">
          {{ order.billingAddress.firstName }} {{ order.billingAddress.lastName }}
        </div>
        <div class="odcb-body">
          {{ order.billingAddress.address1 }}
        </div>
        <div
          v-if="order.billingAddress.address2"
          class="odcb-body"
        >
          {{ order.billingAddress.address2 }}
        </div>
        <div class="odcb-body">
          {{ order.billingAddress.city }},
          {{ order.billingAddress.state }}
          {{ order.billingAddress.zip }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'BillingInformation',
  mixins: [partnerReviewMixin],
};
</script>
